// models/CustomerData.ts

export interface ServicesGroup {
  id: string;
  name: string;
  description?: string;
  services: string[];
}

export interface ThresholdsConfig {
    topn_threshold_items: number;
    topn_threshold_percentage: number;
}
  
/* services: string[]; */ /* moved this to the servicesGroup with id = "all" */

export interface CustomerInfo {
  id: string;
  name: string;
  features: string[]; // e.g., ['pulse', 'probe']
  keyAttributes: string[];
  servicePivotAttribute: string;
  servicesGroup: ServicesGroup[];
  minDateAllowed?: string; // YYYY-MM-DD
  maxDateAllowed?: string; // YYYY-MM-DD
  thresholds: ThresholdsConfig;
}

export interface CustomerListItem {
  id: string;
  name: string;
  api_keys: string[];
}

/* Represents the result of a CRUD operation. */
export interface CrudOperationResult {
    message: string;    /* A message describing the outcome of the operation. */
    customer?: string;  /* The ID of the affected customer (if applicable). */
    error?: string;     /* An error key if the operation failed. */
}


export const getServicesForGroupId = ( customer: CustomerInfo, servicesGroupId: string): string[] => {

  // find the ServicesGroup given the id as servicesGroup
  const sg: ServicesGroup | undefined = customer.servicesGroup.find(sg => sg.id === servicesGroupId);

  return sg ? sg.services : [];
}
